import React, { useEffect, useState } from "react";
import { Divider, Switch, Button, Alert } from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  ReloadOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import IBAccountDetails from "components/UserSettings/IBAccountDetails";
import IBPortfolio from "components/UserSettings/IBPortfolio";
import { apiGetIBAccountDetails } from "api/apiTws";
import OrdersStatus from "components/OrdersStatus/OrdersStatus";
import { Link } from "react-router-dom";
import { paths } from "utils/constants";

const IBIntergration = () => {
  const [ibAccountDetails, setIbAccountDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSensitiveValues, setShowSensitiveValues] = useState(() => {
    const stored = localStorage.getItem("ibAccountShowSensitiveValues");
    return stored ? JSON.parse(stored) : false;
  });
  const fetchIbAccountDetails = async () => {
    try {
      setLoading(true);
      const response = await apiGetIBAccountDetails();
      setIbAccountDetails(response);
    } catch (err) {
      console.error("Failed to fetch IB account details:", err);
      setIbAccountDetails(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIbAccountDetails();
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "ibAccountShowSensitiveValues",
      JSON.stringify(showSensitiveValues)
    );
  }, [showSensitiveValues]);

  const handleToggleSensitiveValues = (checked) => {
    setShowSensitiveValues(checked);
  };

  const handleRefresh = () => {
    fetchIbAccountDetails();
  };

  return (
    <>
      {ibAccountDetails?.connected === false && (
        <Alert
          message="IBKR account not connected"
          type="error"
          action={
            <Button type="link" onClick={handleRefresh}>
              Retry
            </Button>
          }
        />
      )}
      {ibAccountDetails?.connected === true && (
        <>
          <Divider orientation="left">Interactive Brokers Integration</Divider>
          <div
            style={{
              marginBottom: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>Show sensitive values:</span>
              <Switch
                checked={showSensitiveValues}
                onChange={handleToggleSensitiveValues}
                checkedChildren={<EyeOutlined />}
                unCheckedChildren={<EyeInvisibleOutlined />}
              />
            </div>
            <div className="flex items-center gap-2">
              <Link to={paths.userSettings}>
                <Button type="link" icon={<SettingOutlined />}>
                  Settings
                </Button>
              </Link>
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={handleRefresh}
                loading={loading}
              >
                Refresh Data
              </Button>
            </div>
          </div>
          <div className="cards-wrapper">
            {ibAccountDetails?.accountDetails && (
              <IBAccountDetails
                accountData={ibAccountDetails.accountDetails}
                showSensitiveValues={showSensitiveValues}
              />
            )}
            {ibAccountDetails?.portfolio && (
              <IBPortfolio
                portfolioData={ibAccountDetails.portfolio}
                showSensitiveValues={showSensitiveValues}
              />
            )}
          </div>
        </>
      )}
      <OrdersStatus />
    </>
  );
};

export default IBIntergration;
